import request from '@/utils/request'
export function getConfigList(params) {
  return request({
    url: '/saifuneng/saifuneng-device/attr/show/config/info',
    method: 'get',
    params
  })
}

export function pubObj(data) {
  return request({
    url: '/saifuneng/saifuneng-device/attr/show/config/edit',
    method: 'post',
    data
  })
}

export function fetchHeaderList(params) {
  return request({
    url: '/saifuneng/saifuneng-device-data/table/columns',
    method: 'get',
    params
  })
}
